import { render, staticRenderFns } from "./PermissionsItem.vue?vue&type=template&id=ae19574c"
import script from "./PermissionsItem.vue?vue&type=script&lang=js"
export * from "./PermissionsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports